export enum VideoStatus {
  Idle = 'idle',
  NeedsPlay = 'needs-play',
  Playing = 'playing',
}
